import { Button, Card, Icon } from '@elva/ui';

export interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retrying?: boolean;
  compact?: boolean;
}

export function ErrorState({
  title = "Couldn't load this",
  message,
  onRetry,
  retrying = false,
  compact = false,
}: ErrorStateProps) {
  const body = (
    <div
      role="alert"
      className={`flex flex-col items-center gap-3 text-center ${compact ? 'py-6' : 'py-14'}`}
    >
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[var(--terra-1)] text-[var(--terra-4)]">
        <Icon kind="alert" size={20} stroke={2} />
      </span>
      <div>
        <p className="m-0 font-[var(--font-display)] text-[16px] font-semibold text-[var(--ink-0)]">
          {title}
        </p>
        <p className="mx-auto mt-1 max-w-[420px] text-[13px] text-[var(--ink-3)]">{message}</p>
      </div>
      {onRetry ? (
        <Button variant="secondary" size="sm" onClick={onRetry} loading={retrying}>
          Try again
        </Button>
      ) : null}
    </div>
  );

  if (compact) return body;
  return <Card className="mx-auto my-6 w-full max-w-[560px]">{body}</Card>;
}
